import { createFileRoute } from "@tanstack/react-router";

import PlatformStatusPage from "@/features/dashboard/pages/platform-status";

export const Route = createFileRoute("/(app)/dashboard/status")({
  component: PlatformStatusPage,
});
